export const columns = [
  {
    title: "Account Information",
    fields: [
      "account_name",
      "website",
      "organization_type",
      "us_district",
      "city",
      "latest_source",
      "hq",
      "state",
      "duns_num",
      "crunchbase_url",
      "founded",
      "linkedin_url",
      "linkedin_followers",
    ],
  },
  {
    title: "Additional Information",
    fields: ["industry", "employees", "specialties", "slogan"],
  },
  {
    title: "AWS Classification",
    fields: [
      "aws_segment",
      "aws_sub_segment",
      "aws_adoption",
      "aws_partner_status",
      "aws_relationship_strength",
      "aws_main_contacts",
    ],
  },
  {
    title: "MSFT Classification",
    fields: [
      "microsoft_segment_group",
      "microsoft_sub_segment",
      "azure_adoption",
      "microsoft_relationship_strength",
      "microsoft_main_contacts",
      "macc_eligible",
    ],
  },
  {
    title: "Business Insights",
    fields: [
      "partner_type",
      "decision_making",
      "presence",
      "installed_enterprise_technologies",
      "installed_infra_providers",
      "isv_accelerate",
      "ace_eligible",
      "installed_isv_technologies",
      "installed_developer_tools",
      "marketplace_status",
    ],
  },
  {
    title: "Financial & Investment",
    fields: ["funding", "investors", "fortune_num"],
  },
];
export const getFilteredFieldsByVendor = (vendor) => {
  if (vendor === 'aws') {
    return columns.filter(group => group.title !== 'MSFT Classification');
  } else {
    return columns.filter(group => group.title !== 'AWS Classification').map(column => ({
      ...column,
      fields: column.fields.filter(field => field !== "ace_eligible" && field !== "isv_accelerate" && field),
    }));;
  }
}
